import React, { useEffect } from "react";
import { connect } from "react-redux";

import { resetFlowStatuses } from "@app/store/iam/actions";

import AcaActiveDealersTour from "./AcaActiveDealers";
import FrequenciesTour from "./Frequencies";
import GettingStartedChecklist from "./GettingStarted";
import GettingStartedForMobile from "./GettingStartedMobile";
import JasperBulkEditTour from "./JasperBulkEdit";
import JasperSavedFiltersForMobile from "./JasperSavedFiltersForMobile";
import MapOnboarding from "./MapOnboarding";
import PlannerTour from "./Planner";
import ProSomnusCreateDealTour from "./ProSomnusCreateDeal";
import ResourcesChecklist from "./Resources";
import SendingEmailsChecklist from "./SendingEmails";
import TriStateVideoGuides from "./TriStateVideoGuides";

const Guides = ({ onResetFlowStatuses }: typeof mapDispatchToProps) => {
  useEffect(() => {
    window.__mmc_reset_flow_statuses__ = () => {
      if (window.confirm("Are you 100% sure you wanna remove all flows progress?")) {
        onResetFlowStatuses();
        window.alert("Done!");
      }
    };
    return () => {
      delete window.__mmc_reset_flow_statuses__;
    };
  }, [onResetFlowStatuses]);

  return (
    <>
      <AcaActiveDealersTour />
      <GettingStartedChecklist />
      <GettingStartedForMobile />
      <MapOnboarding />
      <FrequenciesTour />
      <JasperBulkEditTour />
      <PlannerTour />
      <ProSomnusCreateDealTour />
      <JasperSavedFiltersForMobile />
      <SendingEmailsChecklist />
      <ResourcesChecklist />
      <TriStateVideoGuides />
    </>
  );
};

const mapDispatchToProps = {
  onResetFlowStatuses: resetFlowStatuses.request,
};

export default connect(null, mapDispatchToProps)(Guides);
